const theme = {
    isBuiltIn: true,
    id: "inc",
    name: "Inc",
    showLogo: true,
    logoScale: 1,
    logoPosition: "left",
    logoOffset: 0,
    showMessage: true,
    showPageNum: true,
    logo: null,
    logo_dark: null,
    showFooterByDefault: null,
    palette_name: "inc",
    defaultSlideColor: "theme",
    defaultBackgroundColor: "background_light",
    styleFonts: 1,
    styleFontWeight: "heavy",
    styleElementStyle: "outlined",
    styleEffect: "none",
    styleDesign: 1,
    styleDecoration: "none_left",
    styleHeaderAlignment: "left",
    styleShape: "circle",
    styleColor: "slide",
    styleBackground: "none",
    styleTitleFont: "robotoslab",
    styleBodyFont: "robotoslab",
    styleWeight: "light",
    styleTitleSlide: "bar_left",
    fontScale: 1,
    iconStyle: "chunky",
    cjkFont: "jp",
    fontHeaderFontId: "raleway",
    fontHeaderWeight: 400,
    fontHeaderLetterSpacing: 0,
    fontHeaderLineHeight: 1.5,
    fontHeaderScaling: 85,
    fontHeaderTextTransform: "auto",
    fontTitleFontId: "raleway",
    fontTitleWeight: 400,
    fontTitleLetterSpacing: 0,
    fontTitleLineHeight: 1.6,
    fontTitleScaling: 90,
    fontTitleTextTransform: "auto",
    fontBodyFontId: "raleway",
    fontBodyWeight: 400,
    fontBodyLetterSpacing: 0.02,
    fontBodyLineHeight: 2,
    fontBodyScaling: 90,
    fontBodyTextTransform: "auto",
};

module.exports = theme;
